import {
  SlotMachineInfo,
  SpinResponse,
  User,
  SpinInfoResponse,
  GambleRequestParams,
  BonusRequestParams,
  BuyFeatureRequestParams,
} from '../models';
import { DataAccessMethodNotImplementedError } from './exceptions/data-access-method-not-implemented.error';

export const DATA_ACCESS_SERVICE_TOKEN = Symbol('DATA_ACCESS_SERVICE_TOKEN');

export abstract class DataAccessService {
  public getUserInfo(): Promise<User> {
    throw new DataAccessMethodNotImplementedError('getUserInfo');
  }

  public start(): Promise<SlotMachineInfo> {
    throw new DataAccessMethodNotImplementedError('spin');
  }

  public spin(prevSpinResponse: SpinResponse | null): Promise<SpinInfoResponse> {
    throw new DataAccessMethodNotImplementedError('spin', prevSpinResponse);
  }

  public buyFeature(params: BuyFeatureRequestParams): Promise<SpinInfoResponse> {
    throw new DataAccessMethodNotImplementedError('buyFeature', params);
  }

  public pickBonus(params: BonusRequestParams): Promise<SpinInfoResponse> {
    throw new DataAccessMethodNotImplementedError('pickBonus', params);
  }

  public gamble<Data = any>(params: GambleRequestParams<Data>): Promise<SpinInfoResponse> {
    throw new DataAccessMethodNotImplementedError('gamble', params);
  }
}
